type Props = {
  width?: number;
  height?: number;
} & React.ComponentProps<"span">;

const EgabidIcon: React.FC<Props> = ({ ...props }) => {
  return (
    <span {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 116 100"
        width="24"
        height="24"
        className="relative left-0.5"
      >
        <path
          fill="#f15a22"
          d="M69.14,20.54c5.27-3.04,7.07-9.77,4.03-15.04-3.04-5.27-9.77-7.07-15.04-4.03-15.69,9.06-31.37,18.11-47.06,27.17-5.27,3.04-7.07,9.77-4.03,15.04,2.06,3.57,5.82,5.55,9.66,5.51,1.12-.01,53.15-2.99,56.15-3.32-1.78,2.43-30.38,46-30.95,46.97-1.96,3.31-2.12,7.55-.06,11.12,3.04,5.27,9.77,7.07,15.04,4.03,15.69-9.06,31.37-18.11,47.06-27.17,5.27-3.04,7.07-9.77,4.03-15.04-3.04-5.27-9.77-7.07-15.04-4.03l-8.06,4.65c-7.93-13.74-15.86-27.47-23.79-41.21l8.06-4.65h0ZM15.05,90.83c-4.8,2.77-10.94,1.13-13.71-3.67-2.77-4.8-1.13-10.94,3.67-13.71,8.8-5.08,17.6-10.16,26.39-15.24.62-.36,1.41-.14,1.77.47l8.74,15.14c.36.62.14,1.41-.47,1.77-8.8,5.08-17.6,10.16-26.39,15.24h0Z"
        />
      </svg>
    </span>
  );
};

export default EgabidIcon;
